import { useEffect } from "react";
import Navbar from "./components/Navbar";
import HeroSection from "./components/HeroSection";
import ProductsSection from "./components/ProductsSection";
import AboutSection from "./components/AboutSection";
import AchievementsSection from "./components/AchievementsSection";
import ContactSection from "./components/ContactSection";
import Footer from "./components/Footer";

const siteUrl = import.meta.env.VITE_SITE_URL || "https://samsung-concrete.co.kr";

const jsonLdData = [
  {
    "@context": "https://schema.org",
    "@type": "Organization",
    name: "삼성콘크리트(주)",
    alternateName: "Samsung Concrete Co., Ltd.",
    url: siteUrl,
    logo: `${siteUrl}/vite.svg`,
    description: "충청북도 음성군에 위치한 블럭식 보강토 옹벽 시스템 전문 제조기업. 30년 이상의 기술력으로 SC보강토 옹벽블록, SC옹벽 축조블록 등을 직접 생산·납품.",
    telephone: "043-883-8566",
    email: "ssc8566@naver.com",
    address: {
      "@type": "PostalAddress",
      streetAddress: "삼성면 덕호로 543",
      addressLocality: "음성군",
      addressRegion: "충청북도",
      postalCode: "27726",
      addressCountry: "KR",
    },
    geo: {
      "@type": "GeoCoordinates",
      latitude: 36.9472,
      longitude: 127.5928,
    },
    sameAs: [],
  },
  {
    "@context": "https://schema.org",
    "@type": "LocalBusiness",
    "@id": `${siteUrl}/#localbusiness`,
    name: "삼성콘크리트(주)",
    image: "https://storage.readdy-site.link/project_files/268c12f9-6f0c-4f04-8429-977039a29bee/b0919aee-9823-4335-80f5-c1f856790c16_-.jpg?v=b542e6abda15520a8dce137d40d0df5c",
    url: siteUrl,
    telephone: "043-883-8566",
    email: "ssc8566@naver.com",
    priceRange: "₩₩",
    address: {
      "@type": "PostalAddress",
      streetAddress: "삼성면 덕호로 543",
      addressLocality: "음성군",
      addressRegion: "충청북도",
      postalCode: "27726",
      addressCountry: "KR",
    },
    geo: {
      "@type": "GeoCoordinates",
      latitude: 36.9472,
      longitude: 127.5928,
    },
    openingHoursSpecification: [
      {
        "@type": "OpeningHoursSpecification",
        dayOfWeek: ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"],
        opens: "07:00",
        closes: "18:00",
      },
      {
        "@type": "OpeningHoursSpecification",
        dayOfWeek: "Saturday",
        opens: "07:00",
        closes: "18:00",
      },
    ],
    hasMap: "https://map.naver.com/v5/search/%EC%B6%A9%EB%B6%81%20%EC%9D%8C%EC%84%B1%EA%B5%B0%20%EC%82%BC%EC%84%B1%EB%A9%B4%20%EB%8D%95%ED%98%B8%EB%A1%9C%20543",
    description: "KS 인증 보강토 옹벽블록 전문 제조기업. SC보강토 옹벽블록, SC옹벽 축조블록, 세코 옹벽 블록, 레디락 옹벽 블록 생산·납품.",
  },
  {
    "@context": "https://schema.org",
    "@type": "WebSite",
    url: siteUrl,
    name: "삼성콘크리트(주)",
    description: "블럭식 보강토 옹벽 시스템 전문 제조기업 삼성콘크리트(주) 공식 홈페이지",
    inLanguage: "ko",
    publisher: {
      "@type": "Organization",
      name: "삼성콘크리트(주)",
    },
  },
  {
    "@context": "https://schema.org",
    "@type": "WebPage",
    url: siteUrl,
    name: "음성 블럭식 보강토 옹벽 전문 삼성콘크리트(주)",
    description: "충북 음성군 삼성콘크리트(주) 공식 홈페이지. SC보강토 옹벽블록, SC옹벽 축조블록, 레디락 등 KS인증 보강토 제품 제조·납품.",
    breadcrumb: {
      "@type": "BreadcrumbList",
      itemListElement: [
        {
          "@type": "ListItem",
          position: 1,
          name: "홈",
          item: siteUrl,
        },
      ],
    },
  },
  {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: [
      {
        "@type": "Question",
        name: "삼성콘크리트 보강토 옹벽블록 제품 종류는 무엇인가요?",
        acceptedAnswer: {
          "@type": "Answer",
          text: "삼성콘크리트(주)는 SC보강토 옹벽블록, SC옹벽 축조블록, SC식생 호안 축조블록, 세코 옹벽 블록, 레디락 옹벽 블록 등 5종의 전문 보강토 옹벽 제품을 생산합니다.",
        },
      },
      {
        "@type": "Question",
        name: "삼성콘크리트 제품은 KS 인증을 받았나요?",
        acceptedAnswer: {
          "@type": "Answer",
          text: "네, 삼성콘크리트(주)는 국가표준 KS F 4419 인증을 획득한 제조기업으로 품질을 보장합니다.",
        },
      },
      {
        "@type": "Question",
        name: "전국 납품이 가능한가요?",
        acceptedAnswer: {
          "@type": "Answer",
          text: "네, 삼성콘크리트(주)는 충청북도 음성군 직접 생산 공장에서 전국 신속 납품 서비스를 제공합니다.",
        },
      },
    ],
  },
];

const HomePage = () => {
  useEffect(() => {
    const scripts: HTMLScriptElement[] = jsonLdData.map((schema) => {
      const script = document.createElement("script");
      script.type = "application/ld+json";
      script.text = JSON.stringify(schema);
      document.head.appendChild(script);
      return script;
    });
    return () => {
      scripts.forEach((s) => {
        if (document.head.contains(s)) document.head.removeChild(s);
      });
    };
  }, []);

  return (
    <div className="min-h-screen">
      <Navbar />
      <main>
        <HeroSection />
        <AboutSection />
        <ProductsSection />
        <AchievementsSection />
        <ContactSection />
      </main>
      <Footer />
    </div>
  );
};

export default HomePage;
